export default {
    copiedComplaint: null,
    productionDepartments: [],
    productionSiteGroups: [],
    productionProcesses: [],
    machines: [],
    reportItems: [],
    users: [],
    responsibleUsers: [],
    uploadCancelTokens: [],
    errorCodeGroups: [],
    errors: [],
    proceedingWays: [],
    statuses: []
}
